import './manyphotocontainer.css';
import PhotoItem from '../PhotoItem/PhotoItem';
import { IcarPhotos } from '../../types/type';

interface ManyPhotoContainerProps {
  carsPhoto: IcarPhotos;
  gosNumber: string;
  rotations?: Record<string, number>;
}

function ManyPhotoContainer({ carsPhoto, gosNumber, rotations = {} }: ManyPhotoContainerProps) {
  return (
    <div className="manyphoto__container">
      <header className="manyphoto__header">
        <div className="manyphoto__title">Фото авто</div>
        <div className="manyphoto__autonumber">{gosNumber}</div>
      </header>
      <div className="myphoto__box">
        <PhotoItem
          title={'Спереди'}
          img={carsPhoto.frontPhoto}
          subClass={'frontPhoto'}
          photoType="front"
          rotation={rotations.front || 0}
          carId={carsPhoto.carID}
        />
        <PhotoItem
          title={'Правый бок'}
          img={carsPhoto.rightPhoto}
          subClass={'rightPhoto'}
          photoType="right"
          rotation={rotations.right || 0}
          carId={carsPhoto.carID}
        />
        <PhotoItem
          title={'Вид сзади'}
          img={carsPhoto.backPhoto}
          subClass={'backPhoto'}
          photoType="back"
          rotation={rotations.back || 0}
          carId={carsPhoto.carID}
        />
        <PhotoItem
          title={'Левый бок'}
          img={carsPhoto.leftPhoto}
          subClass={'leftPhoto'}
          photoType="left"
          rotation={rotations.left || 0}
          carId={carsPhoto.carID}
        />
        <PhotoItem
          title={'Фото багажника'}
          img={carsPhoto.trunkPhoto}
          subClass={'trunkPhoto'}
          photoType="trunk"
          rotation={rotations.trunk || 0}
          carId={carsPhoto.carID}
        />
      </div>
    </div>
  );
}

export default ManyPhotoContainer;
